import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { CheckIcon, ArrowRightIcon, SparklesIcon } from 'lucide-react';
const services = [{
  name: 'Close CRM Consulting',
  subtitle: 'Für den schnellen Start',
  description: 'Perfekt für Unternehmen, die Close CRM selbst nutzen möchten und einen professionellen Start brauchen.',
  price: '',
  features: ['Close CRM Account-Einrichtung', 'Pipeline-Konfiguration (bis 1 Pipeline)', 'Basis-Automatisierungen', 'Datenmigration Beratung', '1 zu 1 Beratung', '4 Wochen 2 mal die Woche einen 1 zu 1 Consulting Call', 'Automatisierungsvorlagen'],
  cta: 'Preis anfragen',
  highlighted: false
}, {
  name: 'Close CRM Set Up',
  subtitle: 'Unser Bestseller',
  description: 'Die komplette Lösung für Unternehmen, die maximale Ergebnisse mit minimalem Aufwand wollen.',
  price: '',
  features: ['Alles aus Close CRM Consulting', 'Pipeline-Konfiguration (bis 3 Pipelines)', 'Erweiterte Automatisierungen', 'Datenmigration (unbegrenzt Kontakte)', 'Alle Integrationen (Make, Zapier, API)', 'Telefonie-Setup inkl. Nummern', 'Custom Reporting Dashboards', 'Intensiv-Training (4 Stunden)', '30 Tage Priority Support'],
  cta: 'Preis anfragen',
  highlighted: true
}, {
  name: 'Managed Service',
  subtitle: 'Rundum-Sorglos',
  description: 'Wir übernehmen die komplette CRM-Administration, damit Sie sich auf den Verkauf konzentrieren können.',
  price: '',
  features: ['Alles aus Close CRM Set Up', 'Dedizierter Account Manager', 'Laufende Prozessoptimierung', 'Neue Automatisierungen nach Bedarf', 'Unbegrenzter Support', 'Monatliche Performance-Reports', 'Monatliche Optimierungs-Calls', 'Priorisierte Feature-Requests', 'SLA mit 4h Reaktionszeit'],
  cta: 'Preis anfragen',
  highlighted: false
}];
export function ServicesSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section className="py-24 lg:py-32 bg-[#0a0a0a]" id="services" ref={ref} data-id="element-258">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-259">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-260">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#0ea5e9]/10 text-[#0ea5e9] text-sm font-medium mb-6" data-id="element-261">
            Unsere Services
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight" data-id="element-262">
            Close CRM Implementierung nach Maß
          </h2>
          <p className="mt-6 text-lg text-gray-400" data-id="element-263">
            Wählen Sie das Paket, das zu Ihren Anforderungen passt. Jedes Paket
            ist individuell anpassbar.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-3 gap-8" data-id="element-264">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className={`relative rounded-2xl ${service.highlighted ? 'bg-gradient-to-b from-[#0ea5e9]/20 to-[#1a1a1a] border-2 border-[#0ea5e9]/50' : 'bg-[#1a1a1a] border border-white/5'}`} data-id="element-265">
              {service.highlighted && <div className="absolute -top-4 left-1/2 -translate-x-1/2" data-id="element-266">
                  <span className="inline-flex items-center gap-1 px-4 py-1.5 rounded-full bg-[#0ea5e9] text-white text-sm font-semibold" data-id="element-267">
                    <SparklesIcon className="w-4 h-4" data-id="element-268" />
                    Beliebteste Wahl
                  </span>
                </div>}

              <div className="p-8" data-id="element-269">
                <div className="mb-6" data-id="element-270">
                  <h3 className="text-2xl font-bold text-white" data-id="element-271">
                    {service.name}
                  </h3>
                  <p className="text-[#0ea5e9] text-sm font-medium mt-1" data-id="element-272">
                    {service.subtitle}
                  </p>
                </div>

                <p className="text-gray-400 text-sm leading-relaxed mb-6" data-id="element-273">
                  {service.description}
                </p>

                <div className="mb-8" data-id="element-274">
                  <span className="text-4xl font-bold text-white" data-id="element-275">
                    {service.price}
                  </span>
                </div>

                <ul className="space-y-3 mb-8" data-id="element-276">
                  {service.features.map((feature, i) => <li key={i} className="flex items-start gap-3" data-id="element-277">
                      <div className="w-5 h-5 rounded-full bg-emerald-500/20 flex items-center justify-center flex-shrink-0 mt-0.5" data-id="element-278">
                        <CheckIcon className="w-3 h-3 text-emerald-400" data-id="element-279" />
                      </div>
                      <span className="text-gray-300 text-sm" data-id="element-280">{feature}</span>
                    </li>)}
                </ul>

                <a href="/Kostenloses-Strategiegespraech" className={`group w-full inline-flex items-center justify-center gap-2 px-6 py-4 rounded-lg font-semibold transition-all duration-200 ${service.highlighted ? 'bg-[#0ea5e9] text-white hover:bg-[#0284c7] shadow-lg shadow-[#0ea5e9]/25' : 'bg-white/5 text-white border border-white/10 hover:bg-white/10'}`} data-id="element-281">
                  {service.cta}
                  <ArrowRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-282" />
                </a>
              </div>
            </motion.div>)}
        </div>

        {/* Custom solution CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.6
      }} className="mt-12 text-center" data-id="element-283">
          <p className="text-gray-400" data-id="element-284">
            Brauchen Sie eine individuelle Lösung?{' '}
            <a href="/Kostenloses-Strategiegespraech" className="text-[#0ea5e9] hover:underline font-medium" data-id="element-285">
              Sprechen Sie mit uns →
            </a>
          </p>
        </motion.div>
      </div>
    </section>;
}